import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Input, FormGroup, Label, Card, CardHeader, CardBody } from "reactstrap";
import axios from "axios";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import AddTicketType from "./AddTicketType";
import PlaceZone from "./PlaceZone";
import SafariVehicles from "./SafariVehicles";
import PriceMaster from "./PriceMaster";
import TicketForm from "../TicketInfo/TicketForm";
import VisitorForm from "../TicketInfo/VisitorForm";
import Timings from "./Timings.js";
import TicketNumber from "./TicketNumber.js";
import { getPlaceListForPrice ,getTicketInfoByPlaceId} from "../../redux/actions/indexActions";
import { useParams } from "react-router-dom";
import GroupBooking from "./GroupBooking.js";
import Multiselect from "multiselect-react-dropdown";
import AddNotice from "./AddNotice.js";


const ToggleCard = ({ title, show, setShow, children }) => (
    <div className="col-md-12 mb-4">
        <Card>
            <CardHeader className="bg-secondary text-white d-flex justify-content-between align-items-center">
                <h6 className="mb-0">{title}</h6>
                <div className="form-check form-switch">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={show}
                        onChange={() => setShow(!show)}
                    />
                    {show ? <FaCheckCircle className="ms-2 text-success" /> : <FaTimesCircle className="ms-2 text-danger" />}
                </div>
            </CardHeader>
            {show && <CardBody>{children}</CardBody>}
        </Card>
    </div>
);

const TicketInfo = () => {
    const { id } = useParams();
    
    const [showAddTicketType, setShowAddTicketType] = useState(false);
    const [showPlaceZone, setShowPlaceZone] = useState(false);
    const [showSafariVehicles, setSafariVehicles] = useState(false);
    const [showPriceMaster, setShowPriceMaster] = useState(false);
    const [showTicketForms, setTicketForms] = useState(false);
    const [showNoticeForms, setTicketNoticeForms] = useState(false);
    const [showGroupBookingForms, setGroupBooking] = useState(false);
    const [showVisitorForm, setVisitorForm] = useState(false);
    const [showTimings, setTimingsForm] = useState(false);
    const [numberOfTicket, setNumberOfTicket] = useState(false);
    const [ticketSubTypeList, setTicketSubTypeList] = useState([]);
    const [placeDropdown, setPlaceDropdown] = useState([]);
    const { indexReducer: { PricePlaceLists } } = useSelector((state) => state);
    const    [placeId, setPlaceId] = useState(0);
    const [selectedValue, setSelectedValue] = useState([]);
    const dispatch = useDispatch();
    const { auth } = useSelector((state) => state.AuthReducer);
    const [errors, setErrors] = useState({});
     const [isDisabled, setIsDisabled] = useState(false); // Disable dropdown after 3 selects

    useEffect(() => {
        const url = id
        ? `/api/admin/v1/edit-booking-form/${id}`
        : `/api/admin/v1/edit-booking-form?place_id=${placeId}`;
        axios(url, {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        })
        .then((res) => {
            const data = res?.data?.bookingForm;
            const editableForms = res?.data?.editableForms;
            setPlaceId(data?.place_id);
            setSelectedValue([{id:data?.place?.id,name:data?.place?.place_name}]);
            setShowAddTicketType(editableForms?.ticketType);
            setTicketForms(editableForms?.ticketForm);
            setGroupBooking(editableForms?.ticketZone);
            setShowPlaceZone(editableForms?.ticketZone);
            setSafariVehicles(editableForms?.safariVehicle);
            setVisitorForm(editableForms?.visitorForm);
            setTimingsForm(editableForms?.timings);
            setShowPriceMaster(editableForms?.priceMaster);
            setNumberOfTicket(editableForms?.ticketsPerday);
            setTicketNoticeForms(editableForms?.ticketNotice);
            dispatch({
                type: "EDIT_BOOKING_FORM_FULFILLED",
                payload: res?.data,
            });
        })
        .catch((err) => {
            console.log("err--->>>>>", err);
            setShowAddTicketType(false);
            setTicketForms(false);
            setGroupBooking(false);
            setShowPlaceZone(false);
            setSafariVehicles(false);
            setVisitorForm(false);
            setTimingsForm(false);
            setShowPriceMaster(false);
            setNumberOfTicket(false);
            setTicketNoticeForms(false);
        });
        dispatch({
            type: "EDIT_BOOKING_FORM_RESET",
            payload: [],
        });
    }, [auth,placeId]);

    useEffect(() => {
        console.log('placeId>>>',placeId,'id>>>>',id);
    },[placeId]);

    useEffect(() => {
        dispatch(getPlaceListForPrice(auth.token));
    }, [dispatch, auth.token]);

    useEffect(() => {
        if (PricePlaceLists?.length) {
        setPlaceDropdown(
            PricePlaceLists.map((item) => ({
            id: item.id,
            name: item.place_name,
            }))
        );
        }
    }, [PricePlaceLists]);

   const handleSelect = (selectedList) => {
    setSelectedValue([selectedList[selectedList.length - 1]]);
    setPlaceId(selectedList[0]?.id);
    
  };

  const handleRemove = () => {
    setSelectedValue([]);
    setPlaceId(0);
  };

    // console.log('editableForms>>',editableForms);
    useEffect(() => {
        axios.get(`api/admin/v1/ticket-sub-type-by-place/${placeId}`)
        .then(({ data }) => setTicketSubTypeList(data.TicketSubTypeList || []))
        .catch((err) => console.log(err));
        dispatch(getTicketInfoByPlaceId(auth.token,placeId));
    }, [placeId]);

    return (
        <div className="container">
            <Card className="mb-4 shadow-sm">
                <CardBody>
                    <FormGroup className="mb-4">
                        <Label className="fw-bold fs-5">Category<span className="text-danger"> *</span></Label>
                        {/* <Input type="select" name="place_id" value={placeId} onChange={(e) => setPlaceId(e.target.value)} invalid={errors.place_id}>
                            <option value="">Select Place</option>
                            {PricePlaceLists.map((item) => (
                                <option key={item.id} value={item.id}>{item.place_name}</option>
                            ))}
                        </Input> */}
                        <Multiselect
                            options={placeDropdown}
                            selectedValues={selectedValue}
                            onSelect={handleSelect}
                            onRemove={handleRemove}
                            displayValue="name"
                            showCheckbox={false}
                            selectionLimit={1}
                            placeholder="Select a Place"
                            showArrow={true}
                            className="text-black"
                        />
                        {errors?.place_id && <div className="text-danger mt-2">{errors.place_id}</div>}
                    </FormGroup>

                    <div className="row">
                        <ToggleCard title="Notice" show={showNoticeForms} setShow={setTicketNoticeForms}>
                            <AddNotice placeId={placeId}  />
                        </ToggleCard>
                        <ToggleCard title="Ticket Type" show={showAddTicketType} setShow={setShowAddTicketType}>
                            <AddTicketType placeId={placeId} ticketSubType={ticketSubTypeList} />
                        </ToggleCard>
                        <ToggleCard title="Ticket Form" show={showTicketForms} setShow={setTicketForms}>
                            <TicketForm placeId={placeId} ticketSubType={ticketSubTypeList} />
                        </ToggleCard>
                        <ToggleCard title="Group Booking" show={showGroupBookingForms} setShow={setGroupBooking}>
                            <GroupBooking addFormType={'groupBooking'} placeId={placeId} />
                        </ToggleCard>
                        <ToggleCard title="Ticket Zone" show={showPlaceZone} setShow={setShowPlaceZone}>
                            <PlaceZone placeId={placeId} />
                        </ToggleCard> 
                        <ToggleCard title="Safari Vehicle" show={showSafariVehicles} setShow={setSafariVehicles}>
                            <SafariVehicles placeId={placeId} />
                        </ToggleCard>
                        <ToggleCard title="Visitor Form" show={showVisitorForm} setShow={setVisitorForm}>
                            <VisitorForm placeId={placeId} ticketSubType={ticketSubTypeList} />
                        </ToggleCard>
                        <ToggleCard title="Timings" show={showTimings} setShow={setTimingsForm}>
                            <Timings placeId={placeId} ticketSubType={ticketSubTypeList} />
                        </ToggleCard>
                        <ToggleCard title="Price Master" show={showPriceMaster} setShow={setShowPriceMaster}>
                            <PriceMaster placeId={placeId} />
                        </ToggleCard>
                        <ToggleCard title="Total No. Of Tickets Per Day" show={numberOfTicket} setShow={setNumberOfTicket}>
                            <TicketNumber placeId={placeId} />
                        </ToggleCard>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

export default TicketInfo;
